module.exports = __webpack_public_path__ + "static/platform-3x-f719675fa487d9cba458b0c6e7c5d5ad.webp";